<template>
  <div class="profile notification is-light">
    <div class="is-pulled-right">
      <profile-pic :user="user" :large="true"/>
    </div>
    <h3>
      <a :href="`//twitter.com/${user.screen_name}`" class="has-text-black has-no-text-decoration"
         target="_blank"><strong>{{ user.name }}</strong></a>
      &nbsp;
      <a :href="`//twitter.com/${user.screen_name}`" target="_blank"><small>@{{ user.screen_name }}</small></a>
    </h3>
    <div class="has-text-grey-dark is-size-7 mb-2">
      <div v-if="user.verified">
        <b-icon icon="check-circle"/>
        <span>Verified</span>
      </div>
      <div v-if="user.lock">
        <b-icon icon="check-circle"/>
        <span>Protected</span>
      </div>
      <div v-if="user.location">
        <b-icon icon="map-pin"/>
        <span>{{ user.location }}</span>
      </div>
      <div v-if="user.profile_url">
        <b-icon icon="external-link-alt"/>
        <span><a :href="user.profile_url.expanded_url">{{ user.profile_url.display_url }}</a></span>
      </div>
      <div v-if="user.created_at">
        <b-icon icon="calendar"/>
        <span>{{ createdAt() }}</span>
      </div>
    </div>
    <div class="block tweet-html is-italic" v-html="user.html"></div>
    <div class="block">
      <div class="control">
        <div class="field is-grouped is-grouped-multiline">
          <div class="control">
            <div class="tags has-addons">
              <span class="tag is-dark">Following</span>
              <span class="tag is-info">{{ user.friends_count.toLocaleString() }}</span>
            </div>
          </div>
          <div class="control">
            <div class="tags has-addons">
              <span class="tag is-dark">Followers</span>
              <span class="tag is-info">{{ user.followers_count.toLocaleString() }}</span>
            </div>
          </div>
          <div class="control">
            <div class="tags has-addons">
              <span class="tag is-dark">Tweets</span>
              <span class="tag is-info">{{ user.statuses_count.toLocaleString() }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!userIsHero">
      <div class="is-flex has-background-white mb-1">
        <div class="is-flex-grow-0 p-1 has-background-dark">
          <b-icon icon="angle-double-left" type="is-white"/>
        </div>
        <div v-if="user.relationship.following" class="is-flex-grow-0 p-1 has-background-success">
          <b-icon icon="check-circle" type="is-white"/>
        </div>
        <div v-else class="is-flex-grow-0 p-1 has-background-danger">
          <b-icon icon="times-circle" type="is-white"/>
        </div>
        <div class="is-flex-grow-1 p-1 pl-2">
          <span v-if="user.relationship.following">follows you</span>
          <span v-else>does not follow you</span>
        </div>
      </div>

      <div class="is-flex has-background-white">
        <div class="is-flex-grow-0 p-1 has-background-dark">
          <b-icon icon="angle-double-right" type="is-white"/>
        </div>
        <div v-if="user.relationship.followed_by" class="is-flex-grow-0 p-1 has-background-success">
          <b-icon icon="check-circle" type="is-white"/>
        </div>
        <div v-else class="is-flex-grow-0 p-1 has-background-danger">
          <b-icon icon="times-circle" type="is-white"/>
        </div>
        <div class="is-flex-grow-1 p-1 pl-2">
          <span v-if="user.relationship.followed_by">you follow</span>
          <span v-else>you do not follow</span>
        </div>
        <div class="is-flex-grow-0 p-1">
          <b-switch
              @input="setFollow"
              passive-type="is-danger"
              type="is-success"
              :left-label="true"
              v-model="user.relationship.followed_by"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
	"user": {
		"id": "229662491",
		"name": "Christian Zetzsche",
		"screen_name": "zedmaster84",
		"protected": false,
		"verified": false,
		"followers_count": 1468,
		"friends_count": 1792,
		"image_url": "https://pbs.twimg.com/profile_images/1201123088093601794/2POphVO3_normal.jpg",
		"url": null,
		"description": "Freelance poker live event reporter 🌍 for @PokerNews, @WPT and other outlets. Semi-professional photographer, travel addict. My opinions are my own.",
		"listed_count": 50,
		"statuses_count": 12909,
		"created_at": "2010-12-23T00:33:52Z"
  }
 */

import {format, formatDistanceToNow, parseISO} from 'date-fns'
import ProfilePic from "./ProfilePic"
import tweets from "../api/tweets";

export default {
  name: "UserProfile",
  components: {ProfilePic},
  props: ['user'],

  computed: {
    profile() {
      return this.$store.state.auth.profile
    },
    userIsHero() {
      return (this.profile && this.profile.screen_name === this.user.screen_name)
    }
  },
  methods: {
    createdAt() {
      let created = parseISO(this.user.created_at)
      let dt = format(created, "MMMM do, yyyy")
      let since = formatDistanceToNow(created)
      return `${dt} (${since} ago)`
    },
    setFollow(val) {
      tweets.setFollow(this.user.screen_name, val)
    }
  }
}
</script>

<style scoped>

</style>
